import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import axiosAuth from "../axiosAuth";
import { OWNERSHIP_CHANGE_PACKET } from "./apiRoutes";

interface mutateProps {
  ocpId: string;
  data: any;
}

const mutateAddOCPClosingEmail = async ({
  ocpId,
  data,
}: mutateProps) => {
  return await axiosAuth.put(
    `${OWNERSHIP_CHANGE_PACKET}/${ocpId}/closing-package/email/draft`,
    data
  );
};

const useAddOCPClosingEmailMutation = (
  queryParams?: UseMutationOptions<
    any,
    Error,
    mutateProps,
    unknown
  >
) =>
  useMutation({
    mutationFn: mutateAddOCPClosingEmail,
    ...queryParams,
  });

export default useAddOCPClosingEmailMutation;
